import React, { useState, useEffect } from 'react';
import SEO from '../components/SEO';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Modal from '../components/Modal';
import SubscribeModal from '../components/SubscribeModal';

//import SubFooter from '../components/SubFooter'
import '../scss/style.scss'

const Layout = props => {

  const [modalVisible, setModalVisible] = useState(false);
  const [stickyTableState, setStickyTableState] = useState('');

  const showModal = () => {
      setModalVisible(true);
  };

  const hideModal = () => {
      setModalVisible(false);
  };



  useEffect(() => {
    if(props.context === 'blog'){
      const popUpTimer = setTimeout(() => {
         showModal()
      }, 15000);

      return () => clearTimeout(popUpTimer)   
    }

  }, []);


  const FormPopUp = () => {
      return(
        <Modal className={'blog-popup'} show={modalVisible} handleClose={hideModal}>
          <SubscribeModal />
        </Modal>
      )
  };

  return (
    <React.Fragment>
      <SEO />
      <div className={`page${props.bodyClass ? ` ${props.bodyClass}` : ''}`}>
        <div id="wrapper" className="wrapper">
          <Header />
          <FormPopUp />
          {props.children}
		  <Footer />
        </div>
      </div>
    </React.Fragment>
  )
}

export default Layout
